module.exports = require('./emitter')
